// import { getLocationSearch } from '@/utils/utils'
// export const privacyChangeDev = () => {
//   let cxname = getLocationSearch().tenantTag;
//   switch (cxname) {
//     case 'fangzhouxing':
//       return '方舟行（厦门）科技有限公司';
//     case 'henghao':
//       return '杭州恒胜科技有限公司';
//     case 'tonggang':
//       return '重庆渐臻科技有限公司';
//     case 'nineh':
//       return '上海久柏易游信息科技有限公司';
//     case 'qianxing':
//       return '前行无限(天津)科技有限公司'
//     case 'fengchi' : 
//       return '上饶优驰科技有限公司'
//     case 'shundao' : 
//       return '泉州市顺道网络科技有限公司'
//     case 'yiyue' : 
//       return '石家庄易约汽车服务有限公司'
//     case 'yimin' :
//       return '兰州益民出行汽车服务有限公司'
//     default: ;
//       return "当前平台"
//   }
// }

// export const emailChangeDev = () => {
//   let cxname = getLocationSearch().tenantTag
//   switch (cxname) {
//     case 'fangzhouxing':
//       return 'shayixi@kongjiantiaoyue.com';
//     case 'henghao':
//       return '82269008@qq.com';
//     case 'tonggang':
//       return 'shayixi@kongjiantiaoyue.com';
//     case 'nineh':
//       return 'shayixi@kongjiantiaoyue.com';
//     case 'qianxing':
//       return 'shayixi@kongjiantiaoyue.com'
//     case 'fengchi' : 
//       return 'juqinghua@kongjiantiaoyue.com'
//     case 'shundao' : 
//       return ''
//     case 'yiyue' : 
//       return 'yiyuechuxing@163.com'
//     case 'yimin' :
//       return ''
//     default: ;
//       return ""
//   }
// }

// export const flowType = () => {
//   let flowName = getLocationSearch().flowTag
//   switch (flowName) {
//     case 'baidu':
//       return '百度地图';
//     case 'tengxun':
//       return '腾讯地图';
//     default: ;
//       return ""
//   }
// }
import config from "@/config";
export const privacyChangeDev =  config.privacyChangeDev
export const emailChangeDev =  config.emailChangeDev
export const flowType =  config.flowType